export default function DobInput({ value, onChange, testid, required = true }) {
  const handle = e => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 8);
    let out = digits;
    if (digits.length > 4) out = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
    else if (digits.length > 2) out = `${digits.slice(0, 2)}/${digits.slice(2)}`;
    onChange(out);
  };
  return <input required={required} inputMode="numeric" placeholder="dd/mm/yyyy" maxLength={10} value={value || ""} onChange={handle} pattern="\d{2}/\d{2}/\d{4}" title="dd/mm/yyyy" data-testid={testid} />;
}
